import React from "react";
import { Navigate } from "react-router-dom";
import PathConstants from "./pathConstants";
import ClaimableAuthenticator from "../components/Shared/ClaimableAuthenticator";

const CoverageFundEligibilityPage = React.lazy(
  () =>
    import("../pages/Product/Eligibility/CoverageFund/CoverageFundEligibility"),
);
const MedicationConditionEligibilityPage = React.lazy(
  () => import("../pages/Product/Eligibility/MedicationConditionEligibility"),
);
const DenialReasonEligibilityPage = React.lazy(
  () => import("../pages/Product/Eligibility/DenialReasonEligibility"),
);
const SubDenialReasonEligibilityPage = React.lazy(
  () =>
    import("../pages/Product/Eligibility/SubDenialReasonEligibility/SubDenialReasonEligibility"),
);
const BMICriteriaFollowUpPage = React.lazy(
  () =>
    import("../pages/Product/Eligibility/SubDenialReasonEligibility/BMICriteriaFollowUp"),
);
const AlternativeConditionEligibilityPage = React.lazy(
  () => import("../pages/Product/Eligibility/AlternativeConditionEligibility"),
);
const PatientInfo = React.lazy(
  () => import("../pages/Product/Eligibility/PatientInfo"),
);
const WhoIsAppealFor = React.lazy(
  () => import("../pages/Product/Eligibility/WhoIsAppealFor"),
);
const EligibilitySuccessPage = React.lazy(
  () => import("../pages/Product/Eligibility/EligibilitySuccess"),
);
const CoverageFundQualifyPage = React.lazy(
  () => import("../pages/Product/Eligibility/CoverageFund/CoverageFundQualify"),
);
const LetsGetStarted = React.lazy(
  () => import("../pages/Product/SetupFlow/LetsGetStarted"),
);
const CoverageFundNotQualifyPage = React.lazy(
  () =>
    import("../pages/Product/Eligibility/CoverageFund/CoverageFundNotQualify"),
);

const routes = [
  {
    path: PathConstants.Root,
    element: <Navigate to={PathConstants.MedicationConditionEligibility} />,
  },
  {
    path: PathConstants.CoverageFundEligibility,
    element: <CoverageFundEligibilityPage />,
  },
  {
    path: PathConstants.MedicationConditionEligibility,
    element: <MedicationConditionEligibilityPage />,
  },
  {
    path: PathConstants.DenialReasonEligibility,
    element: <DenialReasonEligibilityPage />,
  },
  {
    path: PathConstants.SubDenialReasonEligibility,
    element: <SubDenialReasonEligibilityPage />,
  },
  {
    path: PathConstants.BMICriteriaFollowUp,
    element: <BMICriteriaFollowUpPage />,
  },
  {
    path: PathConstants.AlternativeConditionEligibility,
    element: <AlternativeConditionEligibilityPage />,
  },
  {
    path: PathConstants.PatientInfo,
    element: (
      <ClaimableAuthenticator>
        <PatientInfo />
      </ClaimableAuthenticator>
    ),
  },
  {
    path: PathConstants.WhoIsAppealFor,
    element: (
      <ClaimableAuthenticator>
        <WhoIsAppealFor />
      </ClaimableAuthenticator>
    ),
  },
  {
    path: PathConstants.EligibilitySuccess,
    element: <EligibilitySuccessPage />,
  },
  {
    path: PathConstants.CoverageFundQualify,
    element: <CoverageFundQualifyPage />,
  },
  {
    path: PathConstants.CoverageFundNotQualify,
    element: <CoverageFundNotQualifyPage />,
  },
  {
    path: PathConstants.LetsGetStarted,
    element: (
      <ClaimableAuthenticator>
        <LetsGetStarted />
      </ClaimableAuthenticator>
    ),
    className: "body_background_light-volt-fade-down",
  },
];

export default routes;
